import { createAsyncThunk } from "@reduxjs/toolkit";
import userApi from "../../utils/api/userApi";

export const fetchCustomerByEmail = createAsyncThunk(
  'customer/fetchCustomerByEmail',
  async ({ email, customerId }, { rejectWithValue }) => {
    try {
      return await userApi.getCustomerByEmail(email, customerId);
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: error.message });
    }
  }
);
